import request from '@/utils/request'

// 兼容后端可能返回的三种列表结构（复用逻辑）
function normalizeListResponse(res) {
  let dataArray = res.data

  if (!Array.isArray(dataArray) && dataArray && typeof dataArray === 'object') {
    if (Array.isArray(dataArray.data)) {
      const inner = dataArray
      return {
        data: inner.data,
        total: Number(inner.total || inner.records || res.total || res.records || 0)
      }
    }
    const numericKeys = Object.keys(dataArray).filter(k => !isNaN(k))
    dataArray = numericKeys.length > 0
      ? numericKeys.sort((a, b) => Number(a) - Number(b)).map(k => dataArray[k])
      : []
  }

  if (!Array.isArray(dataArray)) dataArray = []

  return {
    data: dataArray,
    total: Number(res.total || res.records || 0)
  }
}

// 查询告警设置列表
export function listAlarmSettings(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.listAlarmSettings',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(normalizeListResponse(res))
      } else {
        reject(new Error(res.msg || '获取告警设置列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增告警设置
export function saveAlarmSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.saveAlarmSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '新增告警设置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改告警设置
export function updateAlarmSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.updateAlarmSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '修改告警设置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除告警设置
export function deleteAlarmSetting(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.deleteAlarmSetting',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除告警设置失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 启用/停用告警设置
export function changeAlarmSettingState(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inspection.changeAlarmSettingState',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '变更告警设置状态失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
